import { create } from 'zustand';

import { createListCrudAction } from 'src/stores/actions/ListCrudActionImpl';
import { TRACK_MAPS_CRUD_CONFIG, TrackMapsSlice } from 'src/stores/config/listCrud';
import { flattenActions } from 'src/stores/lib/flattenActions';
import { StoreGetter, StoreSetter } from 'src/stores/lib/types';

type TrackMapsState = TrackMapsSlice;

const useTrackMapsStore = create<TrackMapsState>()((set, get) => ({
  ...flattenActions([
    createListCrudAction(
      set as unknown as StoreSetter<Record<string, unknown>>,
      get as unknown as StoreGetter<Record<string, unknown>>,
      TRACK_MAPS_CRUD_CONFIG,
    ),
  ]),
  trackMaps: [],
  isLoading: false,
  error: null,
}));

export default useTrackMapsStore;
